import { Dispatch } from "redux";
import { errorHandler } from "../../helpers/Functions";
import { Pagination } from "../../Interfaces/Interfaces";
import AgentService from "../../services/AgentService";
import POSService from "../../services/PosService";

export const getTerminals = (data: any) => {
  const api = new POSService().getAggregatorTerminals(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TERMINALS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getPosAggregatorTransactionsForTab = (data: any) => {
  const api = new POSService().getPosAggregatorTransactions(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "POS_AGGREGATOR_TRANSACTION",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getCoordinatorTerminals = (data: any) => {
  const api = new POSService().getCoordinatorTerminals(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TERMINALS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAgentAssignedTerminals = (data: any) => {
  const api = new POSService().getAgentAssignedTerminals(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "ASSIGNED_TERMINALS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ASSIGNED_TERMINALS",
            payload: [],
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatorAssignedTerminals = (data: any) => {
  const api = new POSService().getAggregatorTerminals(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "ASSIGNED_TERMINALS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getSuperAggregatorAssignedTerminals = (data: any) => {
  const api = new POSService().getSuperAggregatorTerminals(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "ASSIGNED_TERMINALS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getUnAssignedTerminals = (data: any) => {
  const api = new POSService().getUnAssignedTerminals(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "UNASSIGNED_TERMINALS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getUnAssignedTerminalsForSuperAggregator = () => {
  const api = new POSService().getUnAssigneTerminalsForSuperAggregator();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "UNASSIGNED_TERMINALS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getAgentTerminals = (data: any) => {
  const api = new POSService().getAgentTerminals(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TERMINALS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getTerminalDetails = (data: any) => {
  const api = new POSService().getTerminalDetails(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAssignedRequests = (data: any) => {
  const api = new POSService().getAggregatorAssignedRequests(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "REQUESTS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatorRequests = (data: any) => {
  const api = new POSService().agentTerminalRequest(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "REQUESTS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const recommendRequest = (data: any) => {
  const api = new POSService().recommendRequestByAggregator(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "REQUESTS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const retrieveMultipleTerminalsFromAggregator = (data: any) => {
  const api = new POSService().retrieveMultipleTerminalsFromAggregator(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        console.log({ res });
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const retrieveMultipleTerminalsFromAgent = (data: any) => {
  const api = new POSService().retrieveMultipleTerminalsFromAgent(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        console.log({ res });
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const startMultipleTerminalsFromAgent = (data: any) => {
  const api = new POSService().startMultipleTerminalsFromAgent(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        console.log({ res });
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const stopMultipleTerminalsToAgent = (data: any) => {
  const api = new POSService().stopMultipleTerminalsToAgent(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const assignMultipleTerminalsToAgent = (data: any) => {
  const api = new POSService().assignMultipleTerminalsToAgent(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const assignMultipleTerminalsToAggregator = (data: any) => {
  const api = new POSService().assignMultipleTerminalsToAggregator(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const addPNDToMultipleTerminals = (data: any) => {
  const api = new POSService().addPNDToMultipleTerminalsServices(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        console.log({ res });
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const declineRequest = (data: any) => {
  const api = new POSService().declineRequestByAggregator(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          // dispatch({
          //   type: 'REQUESTS',
          //   payload: res,
          // });

          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const retrieveTerminal = (data: any) => {
  const api = new POSService().retrieveTerminal(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const retrieveTerminalAggregatorAction = (data: any) => {
  const api = new POSService().retrieveTerminalAggregator(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const assignTerminal = (data: any) => {
  const api = new POSService().assignTerminal(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const assignMultipleTerminal = (data: any) => {
  const api = new POSService().assignMultipleTerminal(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const assignMultipleTerminalAggregator = (data: any) => {
  const api = new POSService().assignMultipleTerminalToAggregatorServices(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getPOSDashboard = (id: any) => {
  const api = new POSService().getPOSDashboard(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const toggleTerminalState = (id: any) => {
  const api = new POSService().toggleTerminalState(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getPOSTransactions = (data: Pagination) => {
  const api = new POSService().getPOSTransactions(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TRANSACTIONS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatorPOSTransactions = (data: Pagination) => {
  const api = new POSService().getAggregatorPOSTransactions(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          console.log(res);
          dispatch({
            type: "POS_TRANSACTIONS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getPOSTransactionDetails = (id: string) => {
  const api = new POSService().getPOSTransactionDetails(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "TRANSACTIONS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatorAgents = (id: number) => {
  const api = new POSService().getAggregatorAgents(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGENTS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: res,
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getSuperAggregatorAggregators = () => {
  const api = new POSService().getSuperAggregatorAggregator();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "SUPER_AGGREGATOR_AGGREGATORS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: res,
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getCoordinatorPosDashboard = () => {
  const api = new POSService().getCordinatorDashboard();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "DASHBOARD",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const placeTerminalOnPnd = (data: any) => {
  const api = new AgentService().putAccountPNDService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getStartedAndStoppedTerminals = (agentId: number) => {
  const api = new POSService().getStartedAndStoppedTerminals(agentId);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "STARTEDSTOPPEDTERMINALS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "STARTEDSTOPPEDTERMINALS",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "STARTEDSTOPPEDTERMINALS",
          payload: {},
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
